export enum AlertTemplateKey {
  // Task Assignment Alerts
  TASK_ASSIGNMENT_CREATED = 'Task.Assignment.Created',
  TASK_ASSIGNMENT_REJECTED = 'Task.Assignment.Rejected',
  // Task State Alerts
  TASK_STATE_SCHEDULED = 'Task.Assignment.Scheduled',

  // Stillness Alert
  TASK_TRIP_STILLNESS = 'Task.TripProgress.VehicleStillnessExceeded',

  // Start Location Alerts
  TASK_START_VEHICLE_NOT_ASSIGNED = 'Task.Start.VehicleNotAssigned',
  TASK_START_VEHICLE_POSSIBLY_LATE = 'Task.Start.VehiclePossiblyLate',
  TASK_START_VEHICLE_LATE = 'Task.Start.VehicleLate',
  TASK_START_VEHICLE_STILL_LATE = 'Task.Start.VehicleStillLate',
  TASK_START_VEHICLE_ARRIVED = 'Task.Start.VehicleArrived',

  // End Location Alerts
  TASK_END_VEHICLE_POSSIBLY_LATE = 'Task.End.VehiclePossiblyLate',
  TASK_END_VEHICLE_LATE = 'Task.End.VehicleLate',
  TASK_END_VEHICLE_STILL_LATE = 'Task.End.VehicleStillLate',
  TASK_END_VEHICLE_ARRIVED = 'Task.End.VehicleArrived',
}

export enum AlertSeverity {
  URGENT = 'urgent',
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
}

export const ALERT_SEVERITY_BY_TEMPLATE: Record<AlertTemplateKey, AlertSeverity> = {
  [AlertTemplateKey.TASK_ASSIGNMENT_CREATED]: AlertSeverity.INFO,
  [AlertTemplateKey.TASK_ASSIGNMENT_REJECTED]: AlertSeverity.URGENT,
  [AlertTemplateKey.TASK_STATE_SCHEDULED]: AlertSeverity.SUCCESS,
  [AlertTemplateKey.TASK_TRIP_STILLNESS]: AlertSeverity.WARNING,
  [AlertTemplateKey.TASK_START_VEHICLE_NOT_ASSIGNED]: AlertSeverity.WARNING,
  [AlertTemplateKey.TASK_START_VEHICLE_POSSIBLY_LATE]: AlertSeverity.WARNING,
  [AlertTemplateKey.TASK_START_VEHICLE_LATE]: AlertSeverity.URGENT,
  [AlertTemplateKey.TASK_START_VEHICLE_STILL_LATE]: AlertSeverity.URGENT,
  [AlertTemplateKey.TASK_START_VEHICLE_ARRIVED]: AlertSeverity.SUCCESS,
  [AlertTemplateKey.TASK_END_VEHICLE_POSSIBLY_LATE]: AlertSeverity.WARNING,
  [AlertTemplateKey.TASK_END_VEHICLE_LATE]: AlertSeverity.URGENT,
  [AlertTemplateKey.TASK_END_VEHICLE_STILL_LATE]: AlertSeverity.URGENT,
  [AlertTemplateKey.TASK_END_VEHICLE_ARRIVED]: AlertSeverity.SUCCESS,
}
